import axios from 'axios';
import get from 'lodash/get';
import {ProductApi} from '@/api/product';
import Vue from 'vue';

const skuGrid = {
  namespaced: true,

  state: {
    baseProducts: {},
    baseProductsCallbacks: {},
    registerInputs: [],
    collapseState: {},
    minQtySku: [],
    allocatedCounts: {},
  },

  mutations: {
    updateVariantQuantity(state, payload) {
      if (!state.baseProducts[payload.baseSku]) {
        state.baseProducts[payload.baseSku] = [];
      }
      if (payload.qty > 0) {
        let Idx = state.baseProducts[payload.baseSku].findIndex((item) => item.sku === payload.sku);
        if (Idx >= 0) {
          state.baseProducts[payload.baseSku][Idx].qty = payload.qty;
        } else {
          state.baseProducts[payload.baseSku].push({sku: payload.sku, qty: payload.qty});
        }
      } else {
        state.minQtySku.push(payload.sku);
        if (payload.qty === '') {
          Object.entries(state.baseProducts).forEach(([baseSku, items]) => {
            let findElemIndex = items.findIndex((item) => item.sku === payload.sku);
            if (findElemIndex >= 0) {
              state.baseProducts[baseSku].splice(findElemIndex, 1);
            }
          });
          window.store.commit('savedLists/updateEntries', payload.sku);
        }
      }
      state.baseProductsCallbacks[payload.baseSku] = payload.callback;
      state.registerInputs.push(payload.input);
    },

    updateCollapseState(state, collapseStates) {
      Object.entries(collapseStates).forEach(([key, value]) => {
        state.collapseState[key] = value;
      });
    },

    clearBaseProduct(state, baseSku) {
      delete state.baseProducts[baseSku];
    },

    setAllocatedCounts(state, data) {
      if (!data || !Object.keys(data).length) {
        return;
      }

      Object.values(data).forEach((item) => {
        Vue.set(state.allocatedCounts, item.sku, item);
      });
    },
  },

  actions: {
    loadAllocatedCounts({commit}, ids) {
      if (!ids || !ids.length) {
        throw new Error('Wrong array of product IDs given.');
      }

      ProductApi.batchLoadAllocatedData(ids).then((data) => {
        commit('setAllocatedCounts', data);
      });
    },

    addToCart({state}) {
      // Reference the addSkusToCart method in BulkProductGridTabs.vue
      // Gather all of the variants associated with the baseSku as the payload
      let payload = {items: []};
      // Filtering items based on collapsed grids
      Object.entries(state.baseProducts).forEach((data) => {
        if (data.length < 2) {
          return;
        }

        const items = data[1];
        let len = items.length;
        while (len--) {
          payload.items.push(items[len]);
          items.splice(len, 1);
        }
      });

      axios({
        method: 'put',
        url: '/cart/entries',
        data: payload,
      })
        .then((response) => {
          Object.keys(state.baseProductsCallbacks).forEach((baseSku) => state.baseProductsCallbacks[baseSku](response));

          // Advanced Ordering failed items
          if (
            get(response, 'data.meta.feedback.message.basePropertyKey') ===
            'distributor.B2B.advancedOrder.error.cannotAdd'
          ) {
            const items = get(response, 'data.data.cartEntries');
            if (items && items.length) {
              let nonAOItems = [];

              items.forEach((item) => {
                nonAOItems.push({sku: item.sku, itemName: item.itemName});
              });

              window.store.commit('advancedOrdering/setDisplayAddErrorModal', true);
              window.store.commit('advancedOrdering/setNonAOItems', nonAOItems);
            }
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          window.store.commit('savedLists/clearEntries');
          window.store.dispatch('miniCart/fetchMiniCart');

          //clearInputs
          state.registerInputs.forEach((input) => {
            if (payload['items'].some((e) => e.sku === input.sku)) {
              input.$el.value = '';
            } else if (state.minQtySku.includes(input.sku)) {
              input.$el.value = '';
            }
          });
        });
    },

    updateCartOrListColumn(context, {products, responseEntries, colName}) {
      products.forEach((obj) => {
        const itemsIndex = responseEntries.findIndex((item) => item.sku === (obj.code || obj.sku));
        if (itemsIndex >= 0) {
          if (colName === 'skuQtyInSavedList') {
            obj[colName] = responseEntries[itemsIndex].skuQtyInSavedList;
          } else {
            obj[colName] = responseEntries[itemsIndex].qty;
          }
        }
        window.store.commit('savedLists/clearEntries');
        context.state.baseProducts = {};
      });
      return products;
    },
  },
};

export default skuGrid;
